import { Api } from 'shapediver-types';

export type ParametricViewer = Api.ApiInterfaceV2;

export type ShapeDiverValue = string | number | boolean | number[];

export enum ParameterType {
  FLOAT = 'Float',
  INT = 'Int',
  EVEN = 'Even',
  ODD = 'Odd',
  STRING = 'String',
  COLOR = 'Color',
  STRINGLIST = 'StringList',
  BOOL = 'Bool',
  TIME = 'Time',
  FILE = 'File',
}
